module.exports = __webpack_public_path__ + "static/009-a7e27b52a5ff97d80aa755204c054085.jpg";